module.exports = __webpack_public_path__ + "static/img/food-2.989cd91.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/describe/food-2.png
// module id = +6W8
// module chunks = 1